import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_EMPLOYEES_EDIT = Symbol('personnel.edit');

export const EMPLOYEES_EDIT_ROUTE_NAME = Symbol('personnel.edit');

export const EMPLOYEE_GET_EDIT_QUERY_KEY = Symbol('person.edit-get');
export const EMPLOYEE_EDIT_MUTATION_KEY = Symbol('person.edit');
export const EMPLOYEE_EDIT_API_URL = 'admin/personals/:id';

export const EMPLOYEE_RESET_MFA_MUTATION_KEY = Symbol('personal.reset-mfa');
export const EMPLOYEE_RESET_MFA_API_URL = 'admin/personals/:id/clear_google_secret';

export const EMPLOYEES_EDIT_PERMISSIONS = {
  CLEAR_GOOGLE_SECRET: new Permission(PermissionsList.admin.PERSONALS_CLEAR_GOOGLE_SECRET),
};
